import { CreationSetForShowFragment, SingleCreationSetFragment } from '../../generated/graphql';
import { getDemoCreation } from './creation';

export const demoCreationSetData: Array<{
  data: { creationSet: SingleCreationSetFragment | CreationSetForShowFragment };
}> = [
  {
    data: {
      creationSet: {
        id: 'CS01FKQWW74B7X',
        offerId: 'DEMOOFFER1',
        creativeFormats: [
          {
            id: '190523',
            network: { id: '2', key: 'facebook', name: 'Facebook' },
            placement: { id: '2', key: 'facebook_feeds', name: 'Feeds' },
            creativeType: { id: '1', key: 'video', name: 'Video' },
            attribute: {
              aspectRatio: {
                supportingAspectRatioId: '1',
                aspectRatio: { width: 16, height: 9 },
                size: { width: 1920.0, height: 1080.0 },
              },
              playbackTime: { supportingPlaybackTimeId: '2', seconds: 15 },
            },
            resizeBaseId: null,
          },
        ],
        creations: [
          getDemoCreation('CR01FKQWW756X5')!,
          getDemoCreation('CR01FKQWW77KVY')!,
          getDemoCreation('CR01FKQWW7A5S0')!,
        ],
        amount: 3,
        additionalAmount: 0,
        deliveryDueDate: '2019-06-19T06:14:44Z',
        deliveryDueDays: 5,
        expressDueDays: 0,
      },
    },
  },
  {
    data: {
      creationSet: {
        id: 'CS01FKZ3RCDWM2',
        offerId: 'DEMOOFFER2',
        creativeFormats: [
          {
            id: '190612',
            network: { id: '2', key: 'facebook', name: 'Facebook' },
            placement: { id: '2', key: 'facebook_feeds', name: 'Feeds' },
            creativeType: { id: '1', key: 'video', name: 'Video' },
            attribute: {
              aspectRatio: {
                supportingAspectRatioId: '1',
                aspectRatio: { width: 1, height: 1 },
                size: { width: 1080.0, height: 1080.0 },
              },
              playbackTime: { supportingPlaybackTimeId: '2', seconds: 15 },
            },
            resizeBaseId: null,
          },
        ],
        creations: [getDemoCreation('CR01FKZ3RCFZSQ')!],
        amount: 1,
        additionalAmount: 0,
        deliveryDueDate: '2019-11-05T08:40:30Z',
        deliveryDueDays: 5,
        expressDueDays: 0,
      },
    },
  },
];

export const getDemoCreationSet = (id: string) =>
  demoCreationSetData.map((d) => d.data.creationSet).find((cs) => cs.id === id);
